import { removeUndefined } from 'commonUtils/removeUndefined';
import type { QUERY_PARAMS } from 'constants/queryNames';

import { convertCustomerAmountValue } from 'entities/creditForm/lib/mappersToCreditForm/convertCustomerAmountValue';
import { convertDictionaryField } from 'entities/creditForm/lib/mappersToCreditForm/convertDictionaryField';

import type { TCreditFormCommonFields, TCreditFormEntityReducer } from '../../types';

export const mapQueryParamsToCreditForm = (
  state: TCreditFormEntityReducer,
  data: Partial<Record<ValuesOf<typeof QUERY_PARAMS>, string | undefined | null>>,
) => {
  const { dictionaries } = state;
  return removeUndefined({
    amount: data.amount ? convertCustomerAmountValue(data.amount) : undefined,
    period: data.period
      ? (convertDictionaryField(data.period, 'period', dictionaries) as TCreditFormCommonFields['period'])
      : undefined,
    purpose: data.purpose
      ? (convertDictionaryField(data.purpose, 'purpose', dictionaries) as TCreditFormCommonFields['purpose'])
      : undefined,
  });
};
